import queryString from 'query-string';
import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';

type Args = {
  name: string;
};

export function useQueryParamState({
  name,
}: Args): [string | undefined, (value: string | undefined) => void] {
  const history = useHistory();

  const location = useLocation();
  const searchParams = queryString.parse(location.search);

  const rawValue = searchParams[name];
  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  const setValue = useCallback(
    (newValue: string | undefined) => {
      const search = queryString.stringify({
        ...searchParams,
        [name]: newValue,
      });

      history.push({ ...location, search });
    },
    [history, location, name, searchParams]
  );

  return [value || undefined, setValue];
}
